<div class="pdf-page app-aul-018-24" id="aul01824">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center"><b>ROOF VALUATION</b></p>
  <br />
  <p class="font-large">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
  </p>

  <p class="font-small mb-0">
    This endorsement modifies insurance provided under the following:
  </p>
  <p class="font-small mb-0">BUILDING AND PERSONAL PROPERTY COVERAGE FORM</p>
  <p class="font-small">CONDOMINIUM ASSOCIATION COVERAGE FORM</p>
  <br />
  <p class="font-small">The following is added to the Valuation condition.</p>
  <p class="font-small"><b>Roof Surface and Covering Valuation.</b></p>
  <ol class="font-small">
    <li>
      Any damage to a roof surface that has an age greater than the years listed
      in the table below will be subject to actual cash valuation, as defined by
      the policy.
    </li>
    <li>
      The age of roof is calculated as at the date of loss and from the year of
      original construction or the year of a full roof replacement. Full roof
      replacement means removal and replacement of the entire roof surface.
      Partial repairs, recoating or temporary repairs are considered maintenance
      only and do not determine the age of the roof for purposes of this
      endorsement.
    </li>
    <li>
      All other terms and conditions, insured coverage and exclusions of this
      policy remain unchanged, including applicable limits, sublimits and
      deductibles, and apply in full force and effect to the coverage provided
      by this policy.
      <table
        style="
          border: 1px solid black;
          border-collapse: collapse;
          margin-top: 20px;
        "
      >
        <tbody>
          <tr>
            <th style="border: 1px solid black; padding: 5px">
              Type Primary Roof Material
            </th>
            <th style="border: 1px solid black; padding: 5px">
              Age of Roof (In Years)
            </th>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 5px">
              Clay concrete tile, Slate, or similar performing material
            </td>
            <td style="border: 1px solid black; padding: 5px; text-align: center;">25</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 5px">
              Light metal panels, Standing seam metal, Asphalt composite
              shingle, Built-up with gravel or without gravel, or similar
              performing material
            </td>
            <td style="border: 1px solid black; padding: 5px; text-align: center;">15</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 5px">
              Single-ply membrane, Single-ply membrane Ballasted, Thermoplastic
              Polyolefin (TPO) single-ply membrane, or similar performing
              material, and All other
            </td>
            <td style="border: 1px solid black; padding: 5px; text-align: center;">10</td>
          </tr>
        </tbody>
      </table>
    </li>
  </ol>
  <br />
  <p class="font-small">
    <b>All other terms and conditions of this policy remain unchanged.</b>
  </p>
</div>
